export default {
  dym: `Did you mean`,
  navLinkTitle: text => `Did you mean ${text}`
}
